import { useState } from 'react';
import { Drawer, Box, Pagination, ButtonGroup } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { FilterProvider, useFilter, initPlaceFilterValues } from 'contexts/filter';
import { DividerContainer } from 'components/styles_components/container';
import { useError } from 'contexts/error';
import { usePaginate } from 'contexts/paginate';
import FilterForm from 'components/place/filter_form';
import FilterTags from 'components/filter/tags';
import InfoContainer from 'components/info_container';
import CreateButton from 'components/place/button/create';
import FilterButton from 'components/place/button/filter';
import PlacesQuery from 'queries/place/index';
import Index from 'components/place/index';

const IndexContainer = () => {
  const { page, onPageChange } = usePaginate();
  const setError = useError();
  const { placesFilter, setPlacesFilter } = useFilter();
  const [filterVisible, setFilterVisible] = useState(false);
  const [sortBy, setSortBy] = useState('name_asc');
  const {
    data = { space: { overPlacesLimit: false }, places: { places: [], perPage: 10 } },
    loading,
  } = useQuery(PlacesQuery, {
    variables: {
      ...placesFilter,
      page: page,
      sortBy: sortBy,
    },
    onError: () => {
      setError('error.place.index');
    },
  });

  return (
    <FilterProvider>
      {filterVisible && (
        <Drawer
          anchor="right"
          open={filterVisible}
          onClose={() => {
            setFilterVisible(false);
          }}
        >
          <FilterForm
            initialValues={placesFilter}
            defaultValues={initPlaceFilterValues}
            onSubmit={(values) => {
              onPageChange(1);
              setPlacesFilter(values);
            }}
            onClose={() => {
              setFilterVisible(false);
            }}
          />
        </Drawer>
      )}
      <Box display="flex" justifyContent="flex-end">
        <ButtonGroup>
          <CreateButton
            overPlacesLimit={data.space.overPlacesLimit}
            adminRole={data.space.adminRole}
          />
          <FilterButton
            onClick={() => setFilterVisible(!filterVisible)}
            initPlaceFilterValues={initPlaceFilterValues}
            placesFilter={placesFilter}
          />
        </ButtonGroup>
      </Box>
      <FilterTags
        filterValues={placesFilter}
        defaultValues={initPlaceFilterValues}
        onFilterChange={setPlacesFilter}
      />
      <InfoContainer visible={!loading && data.places.placesTotal === 0}>
        <FormattedMessage id="empty.places.title.short" />
      </InfoContainer>
      <Index
        loading={loading}
        places={data.places}
        sortBy={sortBy}
        onSortChange={setSortBy}
      />
      <Box display="flex" justifyContent="center">
        {data.places.placesTotalPages > 1 && (
          <Pagination
            count={data.places.placesTotalPages}
            page={page}
            onChange={(_e, nextPage) => {
              onPageChange(nextPage);
            }}
          />
        )}
      </Box>
      <DividerContainer />
    </FilterProvider>
  );
};

export default IndexContainer;
